import λ from '~/utils/invoker';
import { getId } from '#/object-id';
import ListMixin from '~/mixins/list';
import { routeNames } from '~/router';
import PermissionMixin from '~/mixins/permission';
import PaginatedTable from '~/components/paginated-table.vue';
import ConfirmDialog from '~/components/confirm-dialog.vue';
import GoBackWrapper from '~/components/go-back-wrapper.vue';
import { CreditType } from '#/credit';
import { find, whereEq } from 'ramda';
import { mdiTrashCanOutline, mdiPlusCircleOutline, mdiMagnify, mdiDownload } from '@mdi/js';
const agencyλ = λ.namespaced('agencies');
export default {
    name: 'agency-list',
    mixins: [ListMixin('agencies'), PermissionMixin],
    components: {
        ConfirmDialog,
        GoBackWrapper,
        PaginatedTable,
    },
    data() {
        return {
            mdiMagnify,
            mdiTrashCanOutline,
            mdiPlusCircleOutline,
            mdiDownload,
            query: {
                sortBy: 'name',
                sortDesc: false,
                page: 1,
                itemsPerPage: 10,
                filters: {
                    search: null,
                },
            },
            CreditType
        };
    },
    computed: {
        allAgencies: agencyλ.state('all'),
        totalCount: agencyλ.state('totalCount'),
        selectedYear: λ.vuexState('year'),
        headers() {
            return [
                { text: this.$t('Name'), value: 'name' },
                { text: this.$t('agencies.creditFocoConvention') },
                { text: this.$t('agencies.creditAccConvention') },
                ...(this.canDeleteAgencies ? [{ text: this.$t('Delete'), sortable: false, }] : []),
            ];
        },
    },
    methods: {
        remove: agencyλ.action('remove'),
        downloadExport: agencyλ.action('downloadExport'),
        openItem(item) {
            if (this.canReadAgencies || this.canReadOwnAgency(getId(item))) {
                this.$router.push({
                    name: routeNames.agencies.edit,
                    params: { id: getId(item) }
                });
            }
        },
        addNewItem() {
            this.$router.push({
                name: routeNames.agencies.create,
            });
        },
        removeAgency(agency) {
            this.$refs.deleteDialog
                .open()
                .then(async (doDelete) => {
                if (doDelete) {
                    await this.remove(agency);
                }
            });
        },
        getInitialCredit(type, item) {
            var _a;
            const credit = find(whereEq({ type, year: this.selectedYear }), item.credits);
            return (_a = credit === null || credit === void 0 ? void 0 : credit.initial) !== null && _a !== void 0 ? _a : '';
        },
    },
};
